import Home from './Home';

export default {
  path: '/home',
  component: Home
};
